import { z } from 'zod'
import { DeclarantType } from '@/features/cbam-reporting/hooks/declarants'

export type DeclarantFormData = {
  name: string
  type: DeclarantType | undefined
  identificationNumber: string
  country: string
  street: string
  streetNumber: string
  street2: string
  postCode: string
  city: string
  poBox: string
  subDivision: string
}

const declarantFormSchema = z.object({
  name: z.string().min(1),
  type: z.enum([DeclarantType.IMPORTER, DeclarantType.REPRESENTATIVE]),
  identificationNumber: z.string().min(1),
  country: z.string().min(1),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  street2: z.string().optional(),
  postCode: z.string().optional(),
  city: z.string().optional(),
  poBox: z.string().optional(),
  subDivision: z.string().optional()
})

const declarantUpdateSchema = z.object({
  name: z.string().min(1),
  identificationNumber: z.string().min(1),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  street2: z.string().optional(),
  postCode: z.string().optional(),
  city: z.string().min(1),
  poBox: z.string().optional(),
  subDivision: z.string().optional()
})

export const validateDeclarantForm = (data: DeclarantFormData) => {
  return declarantFormSchema.safeParse(data)
}

export const validateDeclarantUpdateForm = (data: Omit<DeclarantFormData, 'type' | 'country'>) => {
  return declarantUpdateSchema.safeParse(data)
}

export const getInitialFormData = (): DeclarantFormData => ({
  name: '',
  type: undefined,
  identificationNumber: '',
  country: '',
  street: '',
  streetNumber: '',
  street2: '',
  postCode: '',
  city: '',
  poBox: '',
  subDivision: ''
})
